import { render } from "./CreateMedication.vue?vue&type=template&id=47114dbb&scoped=true"
import script from "./CreateMedication.vue?vue&type=script&lang=js"
export * from "./CreateMedication.vue?vue&type=script&lang=js"

import "./CreateMedication.vue?vue&type=style&index=0&id=47114dbb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47114dbb"]])

export default __exports__